import React, { useMemo, useState, useEffect } from 'react';
import { Alert } from '@nackle/paper';
import { getString } from '@nackle/intl-tools';
import classnames from 'classnames';
import { loadTranslations } from '../../services/cmx-service';
import { ApolloClient, InMemoryCache, ApolloProvider, ApolloLink } from '@apollo/client';
import { createGraphqlLink, createAuthLink } from '../../services/apolloService';
import { COURSE_THUMBNAIL_PLACEHOLDER, LE_PLAYER_DOMAIN } from '../../config';
import { DEFAULTS } from '../../const';
import { CourseList } from '..';

const LearningEverywhere = ({
  accessToken,
  environment = 'prod',
  pageSize = DEFAULTS.DEFAULT_PAGE_SIZE,
  locale = DEFAULTS.DEFAULT_LOCALE,
  classNames = '',
  imageSize,
  imageShape,
  layout,
  paginatorPosition,
  paginatorSize,
  buttonSize,
  buttonShape,
  showDescription,
  listSize,
  showCompleteIcon,
  showPlayIcon,
  showResumeIcon,
  paginateRequest = true,
  orderBy = 'id',
  orderAscending = true,
  excludeCompletedCourses = false,
  useSegmentationFilter = true,
  maxImageWidth = DEFAULTS.MAX_IMAGE_WIDTH,
  maxImageHeight = DEFAULTS.MAX_IMAGE_HEIGHT
}) => {
  const [loadedTranslations, setLoadedTranslations] = useState(false);
  const link = useMemo(() => {
    return ApolloLink.from([createAuthLink({
      bearerToken: accessToken
    }), createGraphqlLink({
      env: environment
    })]);
  }, [accessToken, environment]);
  const client = useMemo(() => {
    return new ApolloClient({
      link,
      cache: new InMemoryCache()
    });
  }, [link]);
  const hasError = useMemo(() => {
    if (accessToken) {
      return false;
    } else {
      console.error('No Access Token');
      return true;
    }
  }, [accessToken]);
  useEffect(() => {
    async function fetchTranslations() {
      const result = await loadTranslations(accessToken, locale, environment);

      if (!(result !== null && result !== void 0 && result.success)) {
        console.error('Error loading translations from CMX');
      }

      setLoadedTranslations(true);
    }

    fetchTranslations();
  }, [accessToken, locale, environment]);
  const classes = classnames('learning-everywhere', {
    [classNames]: Boolean(classNames)
  });
  return /*#__PURE__*/React.createElement("div", {
    className: classes
  }, /*#__PURE__*/React.createElement(ApolloProvider, {
    client: client
  }, loadedTranslations && hasError && /*#__PURE__*/React.createElement(Alert, {
    message: getString('error.title'),
    description: getString('error.description'),
    type: "error",
    closable: true,
    showIcon: true
  }), loadedTranslations && !hasError && /*#__PURE__*/React.createElement(CourseList, {
    accessToken: accessToken,
    courseThumbnailPlaceholder: COURSE_THUMBNAIL_PLACEHOLDER({
      env: environment
    }),
    lePlayerDomain: LE_PLAYER_DOMAIN({
      env: environment
    }),
    pageSize: pageSize,
    locale: locale,
    imageSize: imageSize,
    imageShape: imageShape,
    layout: layout,
    paginatorPosition: paginatorPosition,
    paginatorSize: paginatorSize,
    buttonSize: buttonSize,
    buttonShape: buttonShape,
    showDescription: showDescription,
    listSize: listSize,
    showCompleteIcon: showCompleteIcon,
    showPlayIcon: showPlayIcon,
    showResumeIcon: showResumeIcon,
    paginateRequest: paginateRequest,
    orderBy: orderBy,
    orderAscending: orderAscending,
    excludeCompletedCourses: excludeCompletedCourses,
    useSegmentationFilter: useSegmentationFilter,
    maxImageWidth: maxImageWidth,
    maxImageHeight: maxImageWidth
  })));
};

export default LearningEverywhere;
//# sourceMappingURL=LearningEverywhere.js.map